import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { FormsModule } from '@angular/forms';
//import {SharedModule} from '../shared/shared.module';

@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.css'],
    standalone: true,
    imports: [FormsModule],
})
export class SnackBarComponent implements OnInit {

  mensaje = "";
  constructor(@Inject (MAT_SNACK_BAR_DATA) public data: string) { }

  ngOnInit(): void {
    this.mensaje = this.data;
  }

}
